import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "hf-container flex column justify-between" }
const _hoisted_2 = { class: "q-py-xs flex justify-around items-center" }
const _hoisted_3 = { style: {"height":"65px","max-height":"65px","max-width":"200px"} }
const _hoisted_4 = ["src"]

import { onMounted } from 'vue';
import TenantInfo from '@/components/TenantInfo.vue';
import BrandFooter from '@/components/BrandFooter.vue';
import CustomFooter from '@/components/CustomFooter.vue';
import { TenantLite } from '../store/models';
import tenantModule from '@/store/modules/tenantModule';


import { defineComponent, ref, computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';
import colors from 'quasar/src/utils/colors/colors.js';import setCssVar from 'quasar/src/utils/css-var/set-css-var.js';import useQuasar from 'quasar/src/composables/use-quasar/use-quasar.js';;
import { useI18n } from 'vue-i18n';

const name = 'CorporateIdentityLayout';

export default /*#__PURE__*/_defineComponent({
  __name: 'CorporateIdentityLayout',
  setup(__props) {

const route = useRoute();
const router = useRouter();
const store = useStore();
const $q = useQuasar();
const { t, locale } = useI18n();


const tenantLite = ref<TenantLite | null>(null);
const showCustomFooter = ref(false);
const showTermsOfUse = ref(false);
const showPitchYouLogo = ref(false);
const showCopyright = ref(false);
const imprintUrl = ref<string | null>(null);
const dataPrivacyUrl = ref<string | null>(null);
const imprintText = ref<string | null>(null);

  onMounted(async () => {
    loadTenantInfoLite();
  });

  async function loadTenantInfoLite() {
  try {
    tenantLite.value = tenantModule.tenantInfoLite || null;
    if (!tenantLite.value) {
      await tenantModule.loadTenantInfoLite();
      tenantLite.value = tenantModule.tenantInfoLite;
    }
    if (tenantLite.value && tenantLite.value.primaryColor) {
      setCssVar('primary', tenantLite.value.primaryColor);
    }
    if (tenantLite.value && tenantLite.value.secondaryColor) {
      setCssVar('secondary', tenantLite.value.secondaryColor);
    }

    if (tenantLite.value) {
      showCustomFooter.value = tenantLite.value.customFooter;
      showTermsOfUse.value = tenantLite.value.showPitchYouTermsOfUse;
      showPitchYouLogo.value = tenantLite.value.showPitchYouLogo;
      showCopyright.value = tenantLite.value.showCopyright;
      imprintUrl.value = tenantLite.value.imprintUrl || null;
      dataPrivacyUrl.value = tenantLite.value.dataPrivacyUrl || null;
      imprintText.value = tenantLite.value.imprintText || null;
    }
  } catch (error) {
    console.error(error);
  }
  if (!tenantLite.value) {
    router.push({ name: 'invalidtenant' });
  }
}



return (_ctx: any,_cache: any) => {
  const _component_q_header = _resolveComponent("q-header")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_q_page_container = _resolveComponent("q-page-container")!
  const _component_q_layout = _resolveComponent("q-layout")!

  return (_openBlock(), _createBlock(_component_q_layout, {
    view: "hhh lpr fff",
    class: "shadow-3"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_header, {
        elevated: "",
        class: "text-white bg-primary"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                (tenantLite.value && tenantLite.value.logo && '' != tenantLite.value.logo)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: tenantLite.value.logo,
                      style: {"height":"100%"},
                      class: "rounded-borders shadow-4"
                    }, null, 8, _hoisted_4))
                  : (_openBlock(), _createBlock(TenantInfo, {
                      key: 1,
                      tenantLite: tenantLite.value
                    }, null, 8, ["tenantLite"]))
              ])
            ])
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_q_page_container, null, {
        default: _withCtx(() => [
          _createVNode(_component_router_view)
        ]),
        _: 1
      }),
      (showCustomFooter.value)
        ? (_openBlock(), _createBlock(CustomFooter, {
            key: 0,
            showTermsOfUse: showTermsOfUse.value,
            showPitchYouLogo: showPitchYouLogo.value,
            showCopyright: showCopyright.value,
            imprintUrl: imprintUrl.value,
            dataPrivacyUrl: dataPrivacyUrl.value,
            imprintText: imprintText.value
          }, null, 8, ["showTermsOfUse", "showPitchYouLogo", "showCopyright", "imprintUrl", "dataPrivacyUrl", "imprintText"]))
        : (_openBlock(), _createBlock(BrandFooter, {
            key: 1,
            showTermsOfUse: true
          }))
    ]),
    _: 1
  }))
}
}

})